<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    <sb-form-field-label [formField]="formField"></sb-form-field-label>
    <input
        id="form-element-{{ formField.id }}"
        type="text"
        class="form-control"
        appFocus
        [appAutoFocus]="formField.isNeedToFocus"
        [attr.name]="formField.name || formField.id"
        [name]="formField.name || formField.id"
        [placeholder]="formField.placeholder"
        [ngClass]="{ 'ng-invalid': formField.isRequired && !formField.value?.trim() }"
        [required]="formField.isRequired"
        [(ngModel)]="formField.value"
        [pattern]="formField.options?.pattern"
        maxlength="1000"
        #field="ngModel" />
    @if (formService.isSubmitted && field.value && field.errors?.pattern) {
        <div class="text-danger">
            @if (formField.options?.patternErrorText) {
                {{ formField.options?.patternErrorText }}
            } @else {
                {{ 'Invalid field value' | translate }}
            }
        </div>
    }
    @if (formService.isSubmitted && formField.isRequired && !formField.value?.trim()) {
        <div class="text-danger" translate>Please fill this field</div>
    }
</div>
